// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@insite/content-library/Components/LocationSearchForm";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

locationSearchFormStyles.searchResultDisplayNumberGridItem = {
    ...locationSearchFormStyles.searchResultDisplayNumberGridItem,
    css: css`
        justify-content: center;
        align-items: center;
    `,
};

locationSearchFormStyles.locationDisplayNumberText = {
    ...locationSearchFormStyles.locationDisplayNumberText,
    color: "text.link",
};

locationSearchFormStyles.locationNameLink = {
    ...locationSearchFormStyles.locationNameLink,
    color: "text.link",
};

locationSearchFormStyles.searchResultPhoneLink = {
    ...locationSearchFormStyles.searchResultPhoneLink,
    typographyProps: {
        weight: "normal",
    },
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    ...locationSearchFormStyles.searchResultDistanceGridItem,
    width: [6, 6, 4, 4, 4],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    ...locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem,
    width: [4, 4, 2, 2, 2],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = {
    ...locationSearchFormStyles.locationGoogleMapsDirectionLink,
    typographyProps: {
        weight: "normal",
    },
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    ...locationSearchFormStyles.distanceUnitOfMeasureRadioGroup,
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        & > div {
            display: inline-flex;
        }
        & > [class^="RadioStyle"]:first-of-type {
            margin-right: 10px;
        }
        & > ${TypographyStyle as any} {
            padding: 0;
            margin-bottom: 0;
        }
    `,
};

locationSearchFormStyles.locationContentLink = {
    css: css`
        ${TypographyStyle} {
            font-weight: normal;
        }
    `,
};

locationSearchFormStyles.pagination = {
    cssOverrides: {
        pagination: css`
            justify-content: flex-end;
        `,
        perPageSelect: css`
            display: none;
        `,
    },
};
